/**
 * useTaskReminders — add, edit, and remove reminders on a mission.
 */

import { useCallback } from 'react';
import { remindersEqual, normalizeReminders } from '../../../../../utils/missionReminders';

export function useTaskReminders(localSprint, setLocalSprint, recordAction) {
  const handleRemindersChange = useCallback((taskId, reminders, options = {}) => {
    const task = localSprint?.tasks?.find((t) => t.id === taskId);
    const oldReminders = normalizeReminders(task?.reminders);
    const nextReminders = normalizeReminders(reminders);
    if (remindersEqual(oldReminders, nextReminders)) return;

    setLocalSprint((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        tasks: (prev.tasks || []).map((t) =>
          t.id === taskId
            ? { ...t, reminders: nextReminders, updatedAt: new Date().toISOString() }
            : t
        ),
      };
    });

    if (!options.silent && recordAction) {
      const taskName = task?.name || 'Task';
      recordAction({
        type: 'CHANGE_REMINDERS',
        description: `${taskName}: Reminder changed`,
        undo: () => {
          setLocalSprint((prev) => {
            if (!prev) return prev;
            return {
              ...prev,
              tasks: prev.tasks.map((t) =>
                t.id === taskId ? { ...t, reminders: oldReminders } : t
              ),
            };
          });
        },
        redo: () => {
          setLocalSprint((prev) => {
            if (!prev) return prev;
            return {
              ...prev,
              tasks: prev.tasks.map((t) =>
                t.id === taskId ? { ...t, reminders: nextReminders } : t
              ),
            };
          });
        },
      });
    }
  }, [localSprint, setLocalSprint, recordAction]);

  return { handleRemindersChange };
}

export default useTaskReminders;
